import { IAppState } from '../../common/state';
import { NEWBUILDING_SPECIAL_PROJECT } from '../../constants/experiments';

export function selectIsSpecialProjectFeaturesAvailable({ abUseExperiments }: IAppState) {
  const experiment = abUseExperiments.find(e => e.experimentName === NEWBUILDING_SPECIAL_PROJECT);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === 'enabled';
}
